import React, { Component } from 'react';
import { Collapse } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toast } from 'react-toastify';
import ChangeOutgoingService from './modals/changeOutgoingService';
import AddressBook from './modals/AddressBook';
import AskForService from './modals/AskForService';
import { filterPhoneNumber, pasteHandler, toastErrorMsg, keyDownHandler, logData } from '../utils/utils';
import { makeOutgoingCall, resetCall, showWebphone } from '../actions/call';
import "../agent/Styles/darktheme.css";
import "../agent/Styles/blacktheme.css";

class TelephonePanel extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: true,
			showModal: false,
			showAddressBook: false,
			phoneNumberValid: false,
			phone: '',
			columns: [
				{ title: 'company', key: 'company', filter: true, style: { width: '120px' } },
				{ title: 'department', key: 'department', filter: true, style: { width: '120px' } },
				{ title: 'position', key: 'position', filter: true, style: { width: '120px' } },
				{ title: 'name', key: 'name', filter: true, style: { width: '120px' } },
				{ title: 'address', key: 'address_list', filter: true, isArray: true, childKey: 'address', style: { width: '120px' } },
				{ title: 'email', key: 'email_list', filter: true, isArray: true, childKey: 'email', style: { width: '120px' } },
				{ title: 'phoneNumber', key: 'phone_list', filter: true, isArray: true, childKey: 'phone', doCall: true, style: { width: '120px' } },
			],
			link_disabled: false,
		};
	}

	close = (key) => {
		this.setState({ [key]: false });
		if (key == 'showAskForServiceModal') {
			this.setState({
				phone: ''
			});
		}
	}

	open = (key) => {
		if (key == 'showModal' && this.props.agentInfo.ask_for_call_service == '1') {
			return;
		}
		this.setState({ [key]: true });
	}
	// updates phone number in state
	onInputChange = (e) => {
		const phoneNumber = filterPhoneNumber(e.target.value);
		this.setState({
			[e.target.name]: e.target.value,
			phoneNumberValid: phoneNumber.length > 0
		});
	}

	onkeyDownHandler = (event) => {
		keyDownHandler(event, "allowNumbersAndChars");
		// looks for enter key press to trigger call
		if (event.key === "Enter" && this.state.phoneNumberValid) {
			this.makeCall({ asProp: false })
		}
	}

	onPasteHandler = (event) => { 
		pasteHandler(event, "allowNumbersAndChars")

		// console.log(event.target.value, "Pasted Value")
		logData(event.target.value, "Pasted Value")
		const phoneNumber = filterPhoneNumber(event.target.value);
		this.setState({
			phone: event.target.value,
			phoneNumberValid: phoneNumber.length > 0
		});
	}

	// makes call
	// Llamar desde el panel de Telefonia (botón y enter).
    makeCall = (data) => {
        if (! this.state.link_disabled)
        {
            // console.log('CLICK no more!! Panel de telefonia');
            this.state.link_disabled = true;
            setTimeout(() => { 
                this.state.link_disabled = false;
                // console.log('CLICK ok!! Panel de telefonia');
            }, 5000);

            const phoneNumber = data.asProp ? filterPhoneNumber(data.phoneNumber) : filterPhoneNumber(this.state.phone);
            if (phoneNumber.length === 0) 
            {
                toastErrorMsg(this.props.translations.onlyNumbers[this.props.selectedLanguage], this, "onlyNumToast");
                return;
            }

            const payload = { extension: this.props.agentInfo.extension, phone: phoneNumber };
            if (this.props.agentInfo.ask_for_call_service == '0')
            {
                // Llamar por el servicio por defecto.
                this.props.showWebphone(true);
                this.props.resetCall();
                this.props.makeOutgoingCall(payload).then((res) => {

                    if (res.data.result === true)
                    {
                        if (!data.phoneNumber)
                        {
                            this.setState({ phone: '' });
                        }
                    } 
                    else
                    {
                        toastErrorMsg(this.props.translations.callFailed[this.props.selectedLanguage], this, "callFailedToast");
                    }
                
                }, (err) => {
                    const message = err === 'maxTabError' ? 'maxTabError' : 'callFailed';
                    toastErrorMsg(this.props.translations[message][this.props.selectedLanguage], this, "callFailedToast2");
                });

            }
            else
            {
                // Pedir el servicio llamante.
                if (this.props.agentInfo.max_call_tabs != 0 && this.props.activeTabs.length >= this.props.agentInfo.max_call_tabs)
                {
                    toastErrorMsg(this.props.translations.maxTabError[this.props.selectedLanguage], this, "maxTabToast");
                }
                else
                {
                    payload.service_id = this.props.agentInfo.calling_service_id;
                    this.setState({
                        payload,
                        showAskForServiceModal: true
                    });
                }
            }
        }		
    }

	render() {
		const {
			phoneNumberValid
		} = this.state;
		const { translations, selectedLanguage, agentInfo } = this.props;
		return (
			<div className={`panel${this.props.theme} panel-default${this.props.theme}`}>
				<div className={`panel-heading panel-heading${this.props.theme}`}>
					<h3 className="panel-title">
						<a className="show btn-icon" onClick={() => this.setState({ open: !this.state.open })}>
							<span className="icon icon-old-phone icon-right-space" />
							<span className="anchor_text">{translations.telephony[selectedLanguage]}</span>
							<span className="icon icon-select-arrows pull-right" />
						</a>
					</h3>
				</div>
				<Collapse in={this.state.open}>
					<ul className="list-group link-list margin-bottom-0">
						<li className={`list-group-item${this.props.theme}`}>
							<div className="flextable">
								<div className="flextable-item flextable-primary">
									<div className="input-with-icon w-full">
										<input
											type="text"
											name="phone"
											value={this.state.phone}
											onChange={this.onInputChange}
											onKeyDown={this.onkeyDownHandler}
											onPaste={this.onPasteHandler}
											placeholder={translations.number[selectedLanguage]}
											className={`form-control${this.props.theme} input-smm${this.props.theme}`}
										/>
										<span className="icon icon-phone" />
									</div>
								</div>
								<div className="flextable-item">
									<div className="btn-group">
										<button
											type="button"
											onClick={this.makeCall}
											disabled={this.state.phone.length === 0 || !phoneNumberValid}
											className={`btn btn-primary-outline btn-sm btn-primary-outline${this.props.theme}`}>{translations.call[selectedLanguage]}</button>
									</div>
								</div>
							</div>
						</li>
						<li className={`list-group-item${this.props.theme} compress a${this.props.theme}`}><a className="show btn-icon" onClick={() => this.open('showAddressBook')}><span className="icon icon-v-card"></span>&nbsp;&nbsp;<span className="anchor_text">{translations.addressBook[selectedLanguage]}</span></a></li>
						<li className={`list-group-item${this.props.theme} compress a${this.props.theme}`}>
							<a href={undefined} className={`show ${agentInfo.ask_for_call_service == '1' ? `noLink${this.props.theme}` : ''}`} onClick={() => this.open('showModal')}>
								<span className="icon icon-address" />&nbsp;&nbsp;{translations.outgoingService[selectedLanguage]}
								{agentInfo.ask_for_call_service == '0' && <span style={{ marginLeft: 5 }}>{agentInfo.calling_service_name}</span>}
								{agentInfo.ask_for_call_service == '1' && <span style={{ marginLeft: 5 }}>{translations.askBeforeCall[selectedLanguage]}</span>}
							</a>
						</li>
					</ul>
				</Collapse>
				<ChangeOutgoingService showModal={this.state.showModal} handleClose={() => this.close('showModal')} />
				<AskForService
					showModal={this.state.showAskForServiceModal}
					payload={this.state.payload}
					handleClose={() => this.close('showAskForServiceModal')} />
				<AddressBook
					type="incoming"
					callAction="getAddressBook"
					callDataParam="items"
					columns={this.state.columns}
					callsData={this.props.incomingCalls}
					showAddressBook={this.state.showAddressBook}
					handleClose={() => this.close('showAddressBook')}
					headerText={translations.addressBook[selectedLanguage]}
				/>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		agentInfo: state.agentInfo,
		doCall: state.callEvents.doCall,
		phoneNumber: state.callEvents.phoneNumber,
		activeTabs: state.callEvents.events,
		translations: state.languages.translations,
		selectedLanguage: state.languages.selectedLanguage,
		darkMode: state.common.darkMode,
		theme: state.common.theme,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({ makeOutgoingCall, resetCall, showWebphone }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TelephonePanel);



// WEBPACK FOOTER //
// ./src/agent/telephone-panel.jsx